import React from 'react';

import styles from './MainSection.module.scss';
import logo from 'assets/images/mbp.svg';

export default function MainSection() {
  return (
    <div className={styles.mainSection}>
      <div className={styles.content}>
        <div className={styles.titleBox}>
          <h1 className={styles.title}>ABOUT US</h1>
          <div className={styles.logo}>
            <img src={logo} alt="logo" />
          </div>
        </div>
        <div className={styles.textBox}>
          myBasePay offers a cost-effective hiring platform and back-office
          solutions for recruiting, staffing and HR professionals. Our products
          eliminate administrative headaches associated with many time-consuming
          HR functions, including payrolls, compliance and more.
        </div>
      </div>
    </div>
  );
}
